/**
 * Applied when config omits `salesmanAllowed` for issalesman users.
 * Prevents `editsallowed` from becoming undefined (template errors on `.editar`, etc.).
 */
export const DEFAULT_SALESMAN_ALLOWED = {
	printorder: false,
	discounts: false,
	editar: false,
	credit: true,
	editorder: true,
	editbilling: false,
	editshipping: false,
	editcontact: true,
	editprofile: false,
	editnotes: true,
	takepayment: false,
	viewrma: true,
	cancelorder: false,
	savequote: false,
};

/**
 * `salesmanAllowed ?? DEFAULT` is unsafe: `false`, `0`, or `[]` pass through and break `.editar` access.
 */
export function normalizeSalesmanAllowed(fromConfig: unknown): typeof DEFAULT_SALESMAN_ALLOWED {
	if (fromConfig !== null && typeof fromConfig === 'object' && !Array.isArray(fromConfig)) {
		return { ...DEFAULT_SALESMAN_ALLOWED, ...fromConfig };
	}
	return { ...DEFAULT_SALESMAN_ALLOWED };
}

/**
 * Order entry filter strip for issalesman: initial open state.
 * Set explicitly via config `salesmanAllowed.orderEntryFiltersAutoOpen`.
 * If omitted, defaults to true for client `aaprod` only; all other clients false.
 */
export function resolveOrderEntryFiltersAutoOpen(
	config: { env?: { client?: string } } | null | undefined,
	salesmanAllowedRaw: unknown
): boolean {
	const merged = normalizeSalesmanAllowed(salesmanAllowedRaw) as Record<string, unknown>;
	const v = merged.orderEntryFiltersAutoOpen;
	if (typeof v === 'boolean') {
		return v;
	}
	return config?.env?.client === 'aaprod';
}
